<template>
	<div class="ProductPlatform">
		<div class="title">
			<p class="frist">{{ lang.index_products_plat }}</p>
			<p class="second">{{ lang.index_products_info }}</p>
		</div>
		<div class="Product container-main">
			<!-- <el-row :gutter="32">
				<el-col :xs="12" :sm="6" :lg="6" v-for="(cate, index) in cate_list" v-if="index < 4">
					<div class="grid-content bg-purple cursor" :style="{ backgroundImage: `url(${cate.img})` }"
						@click="path('/productplatform/index/' + cate.id)">
						<div class="Product-type">
							<h5>{{ cate.name }}</h5>
							<p></p>
						</div>
					</div>
				</el-col>
			</el-row> -->
			<el-row :gutter="32" style="display: flex;flex-wrap: wrap;">
				<el-col :xs="12" :sm="6" :lg="6" v-for="(cate, index) in cate_list" v-if="index < 7">
					<div class="grid-content bg-purple cursor" :style="{ backgroundImage: `url(${cate.img})` }"
						@click="path('/productplatform/index/' + cate.id)">
						<!-- <img :src="cate.img" width="100%"/> -->
						<div class="Product-type">
							<h5>{{ cate.name }}</h5>
							<p></p>
						</div>
					</div>
					<!-- <div class="grid-content bg-purple cursor"  @click="path('/productplatform/index/'+cate.id)">
						<img :src="cate.img" width="100%"/>
						<div class="Product-type">
							<h5>{{cate.name}}</h5>
							<p></p>
						</div>
					</div> -->
				</el-col>
				<el-col :xs="12" :sm="6" :lg="6">
					<div class="grid-content cursor" style="align-items: center;justify-content: center;"
						:style="{ backgroundImage: 'url(' + require('@/assets/index/more_bj.png') + ')' }"
						@click="path('/productplatform/index/0')">
						<div class="more">
							<div class="title cursor">
								<img src="../../assets/index/arrow-more.png"
									style="margin: 0 0.75rem;width: 1.25rem;height: 1.25rem;" />
								<div class="see">{{ lang.index_view_more }}</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import { getIndexProductCate } from "@/api/store";
import {
	mapState
} from 'vuex'
export default {
	name: "ProductPlatform",
	computed: {
		...mapState({
			lang: state => state.user.lang,
		})
	},
	data() {
		return {
			cate_list: []
		}
	},
	created() {
		this.getIndexProductCate()
	},
	methods: {
		getIndexProductCate() {
			getIndexProductCate().then(res => {
				this.cate_list = res.data.cate_list
			})
		},
		path(routePath) {
			this.$router.push(routePath);
		}

	}
};
</script>

<style lang="less">
.ProductPlatform {
	background-color: #fff;
	width: 100%;
	padding: 1.875rem 0;

	/* display: flex;
        justify-content: center;
        align-items: center; */
	.title {
		margin-bottom: 1.9375rem;

		.frist {
			font-family: SourceHanSansCN, SourceHanSansCN;
			font-weight: bold;
			font-size: 1.75rem;
			color: #333333;
			line-height: 0px;
			text-align: center;
			line-height: 1.75rem;
		}

		.second {
			font-size: 0.875rem;
			color: #333333;
			line-height: 0px;
			text-align: center;
		}
	}

	.Product {
		.el-row {
			margin-bottom: 2rem;

			&:last-child {
				margin-bottom: 0;
			}
		}

		.grid-content {
			// position: relative;
			border-radius: 0.5rem;
			width: 100%;
			margin: 1rem;
			min-height: 22rem;
			overflow: hidden;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			display: flex;
			align-items: end;
			transition: transform 0.3s ease;

			/* 平滑过渡效果 */
			// img{
			// 	transition: transform 0.3s ease; /* 平滑过渡效果 */
			// }
			.Product-type {

				min-height: 22rem;
				// background-image: url('../../assets/index/ProductPlatform_bj.png');
				// background-size: 100% 100%;
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: end;
				padding: 0 1.25rem;

				h5 {
					font-size: 1.25rem;
					color: #333;
					// position: absolute;
					// bottom: 1.825rem;
					// left: 1.25rem;
				}

				p {
					width: 2.375rem;
					height: 0.125rem;
					background-color: #333;
					bottom: 0.625rem;
					// position: absolute;
					// left: 1.25rem;
				}
			}
		}

		.bg-purple:hover {
			transform: scale(1.1);
			/* 放大10% */
		}

	}

}

@media (max-width: 768px) {
	.ProductPlatform .Product .el-row {
		margin-bottom: 0;
	}

	.ProductPlatform .Product .el-row .el-col-xs-12 {
		margin-bottom: 1.5625rem;
	}

	.ProjectLayout {
		padding-bottom: 3rem;
		height: auto !important;
	}

	.ProjectLayout .Project .container-main .content .Project-content {
		display: none;
	}

	.ProductPlatform .Product .grid-content {
		min-height: 16rem;
	}

	.ProductPlatform .Product .grid-content .Product-type {
		min-height: 16rem;
	}

	/* .ProjectLayout .Project .container-main .content .Project-content .Project-title {
		    margin-top: 2rem;
		}
		.ProjectLayout .Project .container-main .content .Project-content .more {
		    margin-top: 1.5rem;
		} */
}

@media (max-width: 480px) {
	.ProductPlatform .Product .grid-content {
		min-height: 18rem;
	}

	.ProductPlatform .Product .grid-content .Product-type {
		min-height: 18rem;
	}

	/* .ProjectLayout .Project .container-main .content .Project-content .Project-title {
		    margin-top: 2rem;
		}
		.ProjectLayout .Project .container-main .content .Project-content .more {
		    margin-top: 1.5rem;
		} */
}
</style>
  <style scoped lang="less">
  
    .more{
      background-color: #fff;
      width: 100%;
      padding: 1.875rem 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      
      .title{
        width: 10rem;
        height: 3.44rem;
        color: #333333;
        border: 1px solid #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        .see{
          font-family: MicrosoftYaHei;
          font-size: 1rem;
          color: #333333;
        }
      }
    }
  </style>
  